import invariant from 'invariant';

export default function getProvinces(params) {
    let { baseUrl, brandId, countryCode } = params;

    invariant(baseUrl, 'baseUrl is a required param of getProvinces()');
    invariant(brandId, 'brandId is a required param of getProvinces()');
    invariant(countryCode, 'countryCode is a required param of getProvinces()');

    // API is a S3 bucket so request is case sensitive
    if (brandId) {
        brandId = brandId.toLowerCase();
    }

    const url = `${baseUrl}api/address_validation/v1/${brandId}/countries/${countryCode}.json`;
    return new Request(url);
}
